//赛事
import axios from "axios"
export default {
    getMatchAsync: async (params) => {//获取赛事列表
        return axios.get('/get_cpgroup_list', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    getDetailAsync: async (params) => {//获取赛事详情
        return axios.get('/contest_project_detail', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    getRulesAsync: async (params) => {//获取赛事规则信息
        return axios.get('/get_grade_rule', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    getIsSign: async (data) => {//获取赛事规则信息
        return axios.post('/look_sign_project', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
}
